<template>
  <div class="tw-relative">
    <label :for="label"></label>
    <input
      type="text"
      class="tw-w-full tw-bg-gray-lightest tw-rounded tw-border-white tw-p-4 focus:tw-border-primary"
      v-model="bank"
      :placeholder="placeHolder"
    />
    <img
      src="@/assets/img/search.svg"
      class="tw-absolute tw-top-3.5 tw-right-2"
      alt="search"
    />
  </div>
</template>

<script>
export default {
  name: "EuropeBankList",

  emits: ["set"],
  computed: {
    bank:{
      get(){
        return this.search
      },
      set(value){
        this.$emit("set", value)
      },
    }
  },
  props: {
    placeHolder: { type: String, default: () => "", required: true },
    label: { type: String, default: () => "", required: true },
    search: { type: String, default: () => "", required: true },
  },
};
</script>

<style lang="scss" scoped></style>
